export function TimeIcon() {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="80"
        cy="80"
        r="80"
        fill="var(--landing-advantages-icon-bg, #E3D5BE)"
        fillOpacity="var(--landing-advantages-icon-bg-opacity, 0.24)"
      />
      <path
        d="M80 26.001C109.77 26.001 134 50.23 134 80C134 109.77 109.77 134 80 134C50.2298 134 26 109.77 26 80C26.0003 50.23 50.23 26.001 80 26.001ZM80 33.2002C54.1882 33.2002 33.2005 54.1882 33.2002 80C33.2002 105.812 54.188 126.801 80 126.801C105.812 126.801 126.8 105.812 126.8 80C126.8 54.1882 105.812 33.2002 80 33.2002ZM72.7998 56.5996C72.8 54.427 74.7618 52.676 77.0117 53.0557C78.7766 53.3368 80 54.9969 80 56.7969V76.4004C80 78.3831 81.6169 79.9998 83.5996 80H99.6035C101.382 80.0002 103.055 81.2246 103.344 82.9893C103.723 85.2391 101.979 87.2002 99.7998 87.2002H83.5996C77.6444 87.2001 72.8001 82.3556 72.7998 76.4004V56.5996Z"
        fill="url(#paint0_linear_43_502)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_43_502"
          x1="80"
          y1="26"
          x2="80"
          y2="134"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--landing-advantages-icon-color-from, #FFA24B)" />
          <stop
            offset="1"
            stopColor="var(--landing-advantages-icon-color-to, #FF7B01)"
          />
        </linearGradient>
      </defs>
    </svg>
  );
}
